"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _handlers;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLink = createLink;
exports.validateLink = validateLink;
exports.authenticate = authenticate;

var _constants = require("./constants");

var _ethereum = _interopRequireDefault(require("./blockchains/ethereum"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var findDID = function findDID(did) {
  return did.match(/(did:(3|muport):[a-zA-Z0-9])\w+/)[0];
};

var handlers = (_handlers = {}, _defineProperty(_handlers, _constants.ADDRESS_TYPES.ethereum, _ethereum.default), _defineProperty(_handlers, _constants.ADDRESS_TYPES.ethereumEOA, _ethereum.default), _defineProperty(_handlers, _constants.ADDRESS_TYPES.erc1271, _ethereum.default), _handlers);
var typeDetectors = [_ethereum.default.typeDetector];

function detectType(_x) {
  return _detectType.apply(this, arguments);
}

function _detectType() {
  _detectType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(address) {
    var _iterator, _step, detect, type;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _iterator = _createForOfIteratorHelper(typeDetectors);
            _context.prev = 1;

            _iterator.s();

          case 3:
            if ((_step = _iterator.n()).done) {
              _context.next = 12;
              break;
            }

            detect = _step.value;
            _context.next = 7;
            return detect(address);

          case 7:
            type = _context.sent;

            if (!type) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", type);

          case 10:
            _context.next = 3;
            break;

          case 12:
            _context.next = 17;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](1);

            _iterator.e(_context.t0);

          case 17:
            _context.prev = 17;

            _iterator.f();

            return _context.finish(17);

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 14, 17, 20]]);
  }));
  return _detectType.apply(this, arguments);
}

function createLink(_x2, _x3, _x4) {
  return _createLink.apply(this, arguments);
}

function _createLink() {
  _createLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(did, address, provider) {
    var opts,
        type,
        produceProof,
        proof,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            opts = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : {};
            _context2.t0 = opts.type;

            if (_context2.t0) {
              _context2.next = 6;
              break;
            }

            _context2.next = 5;
            return detectType(address);

          case 5:
            _context2.t0 = _context2.sent;

          case 6:
            type = _context2.t0;

            if (handlers[type]) {
              _context2.next = 9;
              break;
            }

            throw new Error("creating link with type ".concat(type, ", not supported"));

          case 9:
            produceProof = handlers[type].createLink;
            _context2.next = 12;
            return produceProof(did, address, type, provider, opts);

          case 12:
            proof = _context2.sent;

            if (!proof) {
              _context2.next = 17;
              break;
            }

            return _context2.abrupt("return", proof);

          case 17:
            throw new Error("Unable to create proof with type ".concat(type));

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _createLink.apply(this, arguments);
}

function validateLink(_x5, _x6) {
  return _validateLink.apply(this, arguments);
}

function _validateLink() {
  _validateLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(proof, did) {
    var validate, validProof;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            validate = handlers[proof.type].validateLink;

            if (!(typeof validate !== 'function')) {
              _context3.next = 3;
              break;
            }

            throw new Error("proof with type ".concat(proof.type, " not supported"));

          case 3:
            _context3.next = 5;
            return validate(proof);

          case 5:
            validProof = _context3.sent;

            if (!validProof) {
              _context3.next = 11;
              break;
            }

            validProof.did = findDID(validProof.message);
            return _context3.abrupt("return", validProof);

          case 11:
            return _context3.abrupt("return", null);

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _validateLink.apply(this, arguments);
}

function authenticate(_x7, _x8, _x9) {
  return _authenticate.apply(this, arguments);
}

function _authenticate() {
  _authenticate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(message, address, provider) {
    var type;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return detectType(address);

          case 2:
            type = _context4.sent;
            return _context4.abrupt("return", handlers[type].authenticate(message, address, provider));

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _authenticate.apply(this, arguments);
}